export default __webpack_public_path__ + "static/media/logo-dubbing-vi-v3.15911bf9.svg";